<template>
  <div
    :id="`${source}_routing_forms_tab_analytics`"
    class="flex flex-col gap-2"
  >
    <AnalyticsFilterComponent :allowed-filters="routingFormsAllowedFilters" />

    <RoutingFormGrid :source="`${source}_routing_forms_tab_analytics`" />

    <div class="grid grid-cols-2 gap-2 h-full">
      <RoutingFunnelGraph
        :source="`${source}_routing_forms_tab_analytics`"
        class="col-span-1"
      />

      <OutcomeGraph
        :source="`${source}_routing_forms_tab_analytics`"
        class="col-span-1"
      />
    </div>
  </div>
</template>

<script setup>
import { routingFormsAllowedFilters } from "@/src/constants/analyticConstants.js";
import AnalyticsFilterComponent from "@/src/views/analytics/v2/AnalyticsFilterComponent.vue";
import OutcomeGraph from "@/src/views/analytics/v2/meeting_agent_analytics/routing_forms/OutcomeGraph.vue";
import RoutingFormGrid from "@/src/views/analytics/v2/meeting_agent_analytics/routing_forms/RoutingFormGrid.vue";
import RoutingFunnelGraph from "@/src/views/analytics/v2/meeting_agent_analytics/routing_forms/RoutingFunnelGraph.vue";

const props = defineProps({
  source: { type: String, required: true },
});
</script>
